type ThemeConfig = {
    /**
     * Theme primary color in HEX format
     */
    primaryColor?: string;
};

/**
 * Create bulma css vars for tenant
 */
export function createBulmaCssVars({ primaryColor }: ThemeConfig) {
    const styles: string[] = [':root {'];

    if (primaryColor && primaryColor !== '') {
        const hsl = hexToHSL(primaryColor);
        styles.push(`--color-brand-primary: ${primaryColor};`);
        styles.push(`--bulma-primary-h: ${hsl.h}deg;`);
        styles.push(`--bulma-primary-s: ${hsl.s}%;`);
        styles.push(`--bulma-primary-l: ${hsl.l}%;`);
    }

    styles.push('}');

    const styleElement = document.createElement('style');
    styleElement.innerHTML = styles.join('');
    styleElement.dataset['bulmaTenant'] = 'true';
    document.head.appendChild(styleElement);
}

/**
 * Converts color from HEX into HSL
 * @param hex color as HEX value
 * @returns
 */
function hexToHSL(hex: string) {
    // Remove #
    hex = hex.replace('#', '');

    // Support short hex (#abc)
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((c) => c + c)
            .join('');
    }

    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // Lightness
    const l = (max + min) / 2;

    // Saturation
    const s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    // Hue
    let h = 0;
    if (delta !== 0) {
        switch (max) {
            case r:
                h = ((g - b) / delta) % 6;
                break;
            case g:
                h = (b - r) / delta + 2;
                break;
            case b:
                h = (r - g) / delta + 4;
                break;
        }
        h *= 60;
        if (h < 0) h += 360;
    }

    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100),
    };
}
